<template>
  <div class="component-container" v-if="type === 'faq'">
    <h3 class="component-title">고객지원 <span class="dark-purple">{{totalCount}}</span></h3>
    <div class="component-container">
      <div class="search-customer-wrap" v-if="(faqList && faqTotalCount > 0)">
        <h4 class="search-customer-hd">
          <searchButtonFaq />
          <span>FAQ</span><span class="dark-purple">{{faqTotalCount}}</span>
        </h4>
        <ul class="search-customer-box">
          <li v-for="(faq, index) in faqList" :key="'faq_' + index" @click="clickView('faq', faq.faqid)">
            <span class="search-customer-type">{{faq.faqtypetext}}</span>
            <span class="search-customer-title" v-keyword-color="{keyword:keyword, title:faq.faqtitle}"></span>
          </li>
        </ul>
        <div class="plus-icon" @click="plus('faq')" v-if="!(faqTotalCount === faqList.length)">
          <plus-icon />
        </div>
        <span class="cell-list-more" @click.prevent="clickCustomer('faq')">
          <span>더보기</span>
          <NextButtonWhite />
        </span>
      </div>
      <div class="search-customer-wrap" v-if="(noticeList && noticeTotalCount > 0)">
        <h4 class="search-customer-hd">
          <searchButtonNotice />
          <span>공지사항</span><span class="dark-purple">{{noticeTotalCount}}</span>
        </h4>
        <ul class="search-customer-box">
          <li v-for="(notice, index) in noticeList" :key="'notice_' + index" @click="clickView('notice_view', notice.noticeid)">
            <span class="search-customer-type">{{notice.noticetypetext}}</span>
            <span class="search-customer-title" v-keyword-color="{keyword:keyword, title:notice.noticetitle}"></span>
          </li>
        </ul>
        <div class="plus-icon" @click="plus('notice_list')" v-if="!(noticeTotalCount === noticeList.length)">
          <plus-icon />
        </div>
        <span class="cell-list-more" @click.prevent="clickCustomer('notice_list')">
          <span>더보기</span>
          <NextButtonWhite />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { keywordColor } from '@/common/directives'
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
import searchButtonFaq from '@/assets/svg/common/ic_label_faq.svg'
import searchButtonNotice from '@/assets/svg/common/ic_label_notice.svg'
import PlusIcon from '@/assets/svg/common/ic-ticket-add-n.svg'
export default {
  name: 'CustomerSupport',
  components: {
    NextButtonWhite,
    searchButtonFaq,
    searchButtonNotice,
    PlusIcon
  },
  directives: {
    keywordColor
  },
  props: {
    faqList: {
      type: Array
    },
    faqTotalCount: {
      type: Number
    },
    noticeList: {
      type: Array
    },
    noticeTotalCount: {
      type: Number
    },
    plus: {
      type: Function
    },
    totalCount: {
      type: Number
    },
    keyword: {
      type: String
    },
    type: {
      type: String
    }
  },
  methods: {
    clickCustomer (type) {
      this.$router.push({
        name: type,
        params: {
          keyword: this.keyword
        }
      })
    },
    clickView (type, idx) {
      if (type === 'notice_view') {
        this.$router.push({ 'path': `customer/${type}/${idx}` })
      } else {
        this.$router.push({ 'path': `customer/${type}?faqid=${idx}` })
      }
    }
  }
}
</script>
